import "core-js/modules/es.array.sort.js";
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import ThemeProviderContext from "../../contexes/themeProviderContext";
import MarkdownText from "../MarkdownText";
import { WhiteSpacePreservingTypography, SpaciousPaper } from "../styleComponents";
import LikertScale from "likert-react";
import { BoldTypography, withMargin } from "../styleComponents";
var AnswerPaper = styled(SpaciousPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var ReceivedPeerReview = function ReceivedPeerReview(_a) {
  var questions = _a.questions,
    answer = _a.answer,
    idx = _a.idx,
    receivedReviewsLabels = _a.receivedReviewsLabels;
  var themeProvider = useContext(ThemeProviderContext);
  if (typeof answer.createdAt === "string") {
    answer.createdAt = new Date(answer.createdAt);
  }
  var Title = withMargin(BoldTypography, "0 0 0.5rem !important");
  return React.createElement(AnswerPaper, {
    elevation: 4,
    providedStyles: themeProvider.answerPaperStyles
  }, React.createElement(Title, null, receivedReviewsLabels.peerReviewLabel, " ", idx + 1, " (", answer.createdAt.toLocaleDateString(), ")"), questions.sort(function (e1, e2) {
    return e1.order - e2.order;
  }).map(function (question) {
    var questionAnswer = answer.answers.find(function (a) {
      return a.peerReviewQuestionId === question.id;
    });
    if (!questionAnswer) {
      return React.createElement("div", null);
    }
    return React.createElement("div", {
      key: question.id
    }, React.createElement(PeerReviewQuestionAnswer, {
      questionAnswer: questionAnswer,
      questionTitle: question.title,
      questionBody: question.body
    }));
  }));
};
var PeerReviewQuestionAnswer = function PeerReviewQuestionAnswer(_a) {
  var questionAnswer = _a.questionAnswer,
    questionTitle = _a.questionTitle;
  var answerType = typeof questionAnswer.text === "string" ? "essay" : "grade";
  var Component;
  switch (answerType) {
    case "essay":
      Component = React.createElement(ReceivedEssayAnswer, {
        questionAnswer: questionAnswer,
        questionTitle: questionTitle
      });
      break;
    case "grade":
      Component = React.createElement(ReceivedGradeAnswer, {
        questionAnswer: questionAnswer,
        questionTitle: questionTitle
      });
      break;
    default:
      Component = React.createElement("div", null, "No support for this type of peer review question type: ", answerType);
  }
  return React.createElement("div", null, Component);
};
var ReceivedEssayAnswer = function ReceivedEssayAnswer(_a) {
  var questionTitle = _a.questionTitle,
    questionAnswer = _a.questionAnswer;
  return React.createElement("div", {
    style: {
      paddingRight: "1.5rem",
      marginTop: "1rem"
    }
  }, React.createElement(MarkdownText, null, questionTitle), React.createElement(AnswerPaper, null, React.createElement(WhiteSpacePreservingTypography, {
    variant: "body1"
  }, questionAnswer.text)));
};
var ReceivedGradeAnswer = function ReceivedGradeAnswer(_a) {
  var questionTitle = _a.questionTitle,
    questionAnswer = _a.questionAnswer;
  return React.createElement(LikertScale, {
    key: questionAnswer.peerReviewQuestionId,
    reviews: [{
      question: questionTitle,
      review: questionAnswer.value
    }],
    highlightColor: "#3262c9",
    frozen: true
  });
};
export default ReceivedPeerReview;
var templateObject_1;